import React from 'react'
import { Skeleton,  } from 'antd'
import dayjs from 'dayjs'

import {
    PrescriptionItem,
    PrescriptionDateCategories,
    Title,
    Status,
    Directions,
    Pharmacy,
    SyncMeta,
    Provider,
} from './Prescription.styles'

export const Prescription = ({ prescription, loading, getDispenseUnitById }) => {
    if (!prescription || typeof prescription !== 'object') return null
        
    if (loading) {
        return (
            <PrescriptionItem>
                <Skeleton active paragraph={{ rows: 1 }} />
            </PrescriptionItem>
        )
    }

    const dispenseUnit = getDispenseUnitById(prescription.dispenseUnitId)
    const dispenseUnitName = dispenseUnit?.Name || ''
    const quantity = prescription.quantity || prescription.pillCount || 'N/A'
    const quantityWithUnit = dispenseUnitName ? `${quantity} ${dispenseUnitName}${quantity > 1 ? 's' : ''}` : quantity
    const refills = prescription.refills
    const refillsText = refills != null ? `${refills} refill${refills !== 1 ? 's' : ''}` : null  
    const categories = prescription.categories?.map(category => category.name).join(' / ')
    const lastSyncedDisplay = prescription.lastSyncedAt
        ? dayjs(prescription.lastSyncedAt).format('MMM D, YYYY • h:mm A z')
        : 'Never'
    const { firstName, lastName, credential } = prescription.provider || {}
    const providerName = `${firstName || ''} ${lastName || ''}${credential ? `, ${credential}` : ''}`

    return (
        <PrescriptionItem status={prescription.pharmacyStatus}>
            <PrescriptionDateCategories>{prescription.signedAt ? dayjs(prescription.signedAt).format('MM/DD/YYYY') : 'N/A'} {categories && ` • ${categories}`}</PrescriptionDateCategories>
            <Title>{prescription.name} • {quantityWithUnit}{refillsText && ` • ${refillsText} ${prescription.daysSupply ? `• ${prescription.daysSupply} days` : ''}`}</Title>
            <Directions>{prescription.directions}</Directions>
            <Pharmacy>{prescription.pharmacy?.name || 'N/A'} </Pharmacy>
            <Status>Status: {prescription.pharmacyStatus}</Status>
            <Provider>Written by {providerName} {prescription.signedAt ? `on ${dayjs(prescription.signedAt).format('MM/DD/YYYY')}` : ''}</Provider>
            <SyncMeta>Last synced: {lastSyncedDisplay}</SyncMeta> 
        </PrescriptionItem>
    )
}
